import { Link as GatsbyLink } from 'gatsby';
import React from 'react';

const http = 'http';

export const Link = ({
  children,
  href = '#',
  alt,
  className,
  rel,
  target = '_blank',
  dataText,
  style,
  activeClassName,
  state,
  title,
}) => {
  const attrs = {
    className,
    style,
    rel,
    title,
  };

  if (href.startsWith(http)) {
    return (
      <a href={href} target={target} alt={alt} data-text={dataText} {...attrs}>
        {children}
      </a>
    );
  }
  return (
    <GatsbyLink
      {...attrs}
      to={href}
      activeClassName={activeClassName}
      state={state}
      partiallyActive={true}
      data-text={dataText}
    >
      {children}
    </GatsbyLink>
  );
};
